import { lazy } from 'react';

export const NewBuild = lazy(() => import('./Build.component'));
